// extracted by mini-css-extract-plugin
var _1 = "#6f42c1";
var _2 = "#1A2B38";
export { _1 as "ballColor", _2 as "pinColor" }
